import { DotBar } from "./DotBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

export const ResultCategory = ({
  label,
  text,
  percentage,
  percentileId,
  onClickFunction,
  dotId,
}) => {
  return (
    <div className="result-category">
      <span className="label-box">{text}</span>
      {"  "}
      <span className="label-text">
        in {label}{" "}
        <span className="percentile-text">
          {"("}
          <span id={`${percentileId}`}></span>
          {") "}
        </span>
        <span className="results-info-button">
          <FontAwesomeIcon
            icon={faInfoCircle}
            size={window.innerWidth < 768 ? "1x" : "1.5x"}
            onClick={onClickFunction}
            style={{ cursor: "pointer" }}
          />
        </span>
      </span>
      <DotBar percentage={percentage} dotId={dotId} />
    </div>
  );
};
